var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1ZM7 4.96C6.93434 4.96 6.86932 4.97293 6.80866 4.99806C6.748 5.02319 6.69288 5.06002 6.64645 5.10645C6.60002 5.15288 6.56319 5.208 6.53806 5.26866C6.51293 5.32932 6.5 5.39434 6.5 5.46V10.54C6.4999 10.6315 6.52492 10.7214 6.57235 10.7996C6.61979 10.8779 6.6878 10.9417 6.76899 10.984C6.85017 11.0263 6.94141 11.0455 7.03275 11.0395C7.1241 11.0335 7.21204 11.0025 7.287 10.95L10.915 8.41C10.981 8.36392 11.0349 8.30258 11.0722 8.2312C11.1094 8.15982 11.1288 8.08051 11.1288 8C11.1288 7.91949 11.1094 7.84018 11.0722 7.7688C11.0349 7.69742 10.981 7.63608 10.915 7.59L7.287 5.05C7.20284 4.99125 7.10264 4.95983 7 4.96Z",
    fill: "#E71111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.4661aea3831cb413c9047995a15b318e.svg";
export { ForwardRef as ReactComponent };